<template>
  <div class="lg:block bg-cover bg-no-repeat hero-image">
    <div
      class="relative min-h-screen lg:flex lg:justify-end lg:py-20 lg:pl-8 lg:pr-8"
    >
      <div class="lg:pb-16 md:w-1/2 lg:w-1/2">
        <div class="px-8 pt-16">
          <div class="flex flex-col items-center">
            <img src="@assets/kegbit.svg" width="340px" class="mb-8" />

            <div class="text-white text-3xl text-center blah mb-8">
              The First-ever Customizable
              <br />
              Wifi-Connected, ePaper Tap Handle
            </div>

            <img src="@assets/bar.svg" style="height:10px;" class="mb-8" />

            <img
              src="@assets/check_out_our.svg"
              class="mb-8"
              style="height:18px;"
            />
            <a
              href="https://www.kickstarter.com/projects/999804387/kegbit-tap?ref=3y17ii"
              class="mb-8"
              target="_blank"
            >
              <img src="@assets/kickstarter.png" style="height:50px;" />
            </a>

            <img src="@assets/bar.svg" style="height:10px;" class="mb-8" />

            <div class="flex flex-row items-center">
              <a
                href="https://www.facebook.com/KegBit-Tap-100309668097116"
                target="_blank"
              >
                <i class="fab fa-facebook-square fa-3x icons-orange mr-10"></i>
              </a>
              <a href="https://www.instagram.com/kegbit/" target="_blank">
                <i class="fab fa-instagram fa-3x icons-orange"></i>
              </a>
              <a href="https://twitter.com/kegbit" target="_blank">
                <i class="fab fa-twitter fa-3x icons-orange ml-10"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Home',
  components: {},
};
</script>

<style>
.blah {
  font-family: museo, serif;
  font-weight: 700;
  font-style: normal;
}

.icons-orange {
  color: #e3a824;
}

@media screen and (min-width: 1025px) {
  .hero-image {
    background-image: url('/img/Kegbit_HERO.jpg');
  }
}

@media screen and (max-width: 1024px) {
  .hero-image {
    background-image: url('/img/Kegbit_HERO@0.75x.jpg');
  }
}

@media screen and (max-width: 640px) {
  .hero-image {
    background-image: url('/img/Kegbit_HERO@0.5x.jpg');
  }
}
</style>
